<template src="./Footer.html"></template>

<script>
import FB from 'svg/facebook.svg';
import INS from 'svg/instagram.svg';
import VB from 'svg/viber.svg';
import VK from 'svg/vk.svg';
import WA from 'svg/whatsapp.svg';

export default {
  components: {
    FB, INS, VB, VK, WA,
  },
  data() {
    return {
      actualYear: new Date().getFullYear(),
    };
  },
};
</script>

<style lang="scss">
@import "~styles/vars.scss";
@import "~styles/logo_animations.scss";

.footer{
  width: 100%;
  background-color: #fff;
  height: 123px;
  font-size: 12px;
  letter-spacing: 0.8px;
  clear: both;
  overflow: hidden;

  &.main{
    background-color: transparent;
    position: fixed;
    bottom: 0;
    left: 0;
    animation: fadeIn 1s ease-out forwards;
    animation-delay: 1.4s;
    opacity: 0;

    .footer_socials{
      display: none;
    }
    @media only screen and (max-width : $tablet){
      opacity: 1;
      animation: none;
    }
    @media only screen and (max-width : $phone){
      display: none;
    }
  }
}
.footer_copy{
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);

  @media only screen and (max-width : $phone){
    top: 27.03125vw;
    transform: none;
    position: relative;
    display: block;
    text-align: center;
    padding-bottom: 5.65625vw;
    font-size: 2.8125vw;
    letter-spacing: 0.1875vw;
  }
}
.footer_redis{
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);

  a{
    border-bottom: 1px solid $dark-gray;
    transition: all 0.35s;
    color: $dark-gray;

    &:hover{
       border-bottom: 1px solid rgba(255,255,255,0);
    }
  }

  @media only screen and (max-width : $phone){
    top: 16.6875vw;
    transform: none;
    position: relative;
    display: block;
    text-align: center;
    margin-bottom: 10vw;
    font-size: 2.8125vw;
    letter-spacing: 0.1875vw;
  }
}
.footer_socials{
  display: block;
  margin: 0 auto;
  text-align: center;
  padding-top: 50px;

  @media only screen and (max-width : $phone){
    padding-top: 3.28125vw;
  }
}
.footer_social{
  display: inline-block;
  width: 27px;
  height: 22px;
  margin: 0 32px;

  &:hover{
    svg{
      fill: $dark-gray;
    }
  }

  svg{
    fill: #D3D8D8;
    transition: fill 0.35s;
  }

  @media only screen and (max-width : $tablet){
    margin: 0 16px;
    &:nth-child(4), &:nth-child(5){
      display: none;
    }
  }

  @media only screen and (max-width : $phone){
    width: 7.03125vw;
    height: 7.03125vw;
    margin: 0 5vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue